import React from "react";
import {BaseProps} from "../../../../infrastructure/models/props/base-props";
import type {
  PlayersStatisticsTableColumnGroupViewModel
} from "../../../../domain/yard/lineups/players-statistics/tables/columnsGroups/players-statistics.table.column-group.view-model";
import {BoxScoresWidgetTableStatsColumns} from "./box-scores-widget.table-stats.columns";
import classnames from "classnames";
import styles from "../../styles/box-scores-widget.module.scss";

class BoxScoresWidgetTableStatsColumnsGroupsProps extends BaseProps {
  columnGroups: Array<PlayersStatisticsTableColumnGroupViewModel>;
}

export const BoxScoresWidgetTableStatsColumnsGroups = (({columnGroups}: BoxScoresWidgetTableStatsColumnsGroupsProps) => {

  return (
      <div className={classnames(styles.table_row_grouped)}>
        {
          columnGroups.map((columnGroup) => {
          return (
              <div key={columnGroup.order} className={classnames(styles.table_grouped_column)}>
                <div className={classnames(styles.table_grouped_column_main)}>
                  {columnGroup.name}
                </div>
                <div className={classnames(styles.table_grouped_column_sub)}>
                  <BoxScoresWidgetTableStatsColumns columns={columnGroup.columns}/>
                </div>
              </div>
          );
        })}
      </div>
  );
});
